module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/7c60e236ec7e3cd0ffa87ca82bdf0dea.png";